import React, { useState } from 'react'
import Modal from 'react-modal'
import { useDispatch, useSelector } from 'react-redux'
import { mergeVendors } from '../../../common/redux/collectionActions'
import { swalNotify } from '../../../common/components/Swaler'
import { getModalStyles } from '../../../common/utils'
import './styles.css'

type Props = {
  vendor: { _id: String, name: String, email: String, tags: [String] },
  closeModal: Function,
}

const MergeVendorsModal = ({ vendor, closeModal }: Props) => {
  const dispatch = useDispatch()
  const vendors = useSelector((state) => state.collectionData.vendors)
    .filter((v) => v._id !== vendor._id)
    .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))

  const [originalVendor, setOriginalVendor] = useState()

  const save = () => {
    dispatch(mergeVendors(vendor._id, originalVendor, vendor.tags && vendor.tags.length ? vendor.tags : [vendor.email])).then((t) => {
      swalNotify('Sparat!')
      closeModal()
    })
  }

  const originalVendorName = originalVendor && vendors.find((v) => v._id === originalVendor).name
  return (
    <Modal ariaHideApp={false} isOpen={true} onRequestClose={closeModal} style={getModalStyles(0.5)} contentLabel="E">
      <center>
        <div className="qCloseButton" onClick={closeModal}>
          Stäng
        </div>

        <h3>{`Falsk leverantör: ${vendor.name}`}</h3>

        <br />
        <br />
        <h3>Ange originalleverantör:</h3>

        <select onChange={(e) => setOriginalVendor(e.target.value)}>
          {vendors.map((v) => (
            <option key={v._id} value={v._id}>
              {v.name}
            </option>
          ))}
        </select>

        <br />
        <br />
        <br />
        <br />
        {originalVendor && (
          <div>
            <h3 style={{ color: 'red' }}>{`OBS! ${vendor.name} kommer att försvinna. Taggarna och leveranserna för ${vendor.name} kommer sättas på ${originalVendorName}`}</h3>
            <h3>
              <span style={{ textDecoration: 'line-through' }}>{vendor.name}</span>
              {`  ====> ${originalVendorName}`}
            </h3>
            <br />
            <br />
            <div className="qSaveButton" onClick={save}>
              Spara
            </div>
          </div>
        )}
      </center>
    </Modal>
  )
}

export default MergeVendorsModal
